// The shared EquaOS assistant's browser client, loaded at run time from the
// assistant service on this same address (Equall-Agent-Runtime, served at
// /api/assistant/client/). bound.js carries its own React and design-system
// pieces and renders under its own React root in a div Hiring owns, so it
// never touches Hiring's React tree. It is always the service's own version.
//
// webpackIgnore: the browser imports the URL itself; webpack must not try to
// bundle it.

const CLIENT_URL = '/api/assistant/client/bound.js';

let loading = null;

export function loadAssistantClient() {
  if (!loading) {
    loading = import(/* webpackIgnore: true */ CLIENT_URL).then((mod) => {
      if (!mod || typeof mod.mountAssistant !== 'function' || typeof mod.equallRespond !== 'function') {
        throw new Error('not the assistant client');
      }
      return mod;
    });
    // A failure (not deployed yet, offline) may be tried again on the next page.
    loading.catch(() => { loading = null; });
  }
  return loading;
}
